export default "__VITE_ASSET__40852687__"